import { render, staticRenderFns } from "./omie.vue?vue&type=template&id=5bd96caa&"
import script from "./omie.vue?vue&type=script&lang=js&"
export * from "./omie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd96caa')) {
      api.createRecord('5bd96caa', component.options)
    } else {
      api.reload('5bd96caa', component.options)
    }
    module.hot.accept("./omie.vue?vue&type=template&id=5bd96caa&", function () {
      api.rerender('5bd96caa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/omie.vue"
export default component.exports